export default "__VITE_ASSET__pNNT6Moo__"